// billFetchSaga.ts
import { call, put, takeLatest } from "redux-saga/effects";
import {
  billFetchRequested,
  billFetchSucceeded,
  billFetchFailed,
} from "./billFetchSlice";
import {
  BillFetchPayload,
  BillFetchResult,
} from "features/bbps/biller/billerFlowTypes";
import { billerDetailsHttp } from "services/axios.services/instances/billerHttp";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";
import { refSessionStore } from "shared/storage/bbps/RSIdStore";

// types/billerTypes.ts
export interface BillFetchApiResponse {
  data: BillFetchResult;
  status: boolean;
  statusCode: number;
  message: string;
  errors?: any;
}

function* handleBillFetch(action: { type: string; payload: BillFetchPayload }) {
  try {
    const payload = action.payload;

    // console.log("sdfsdf", payload);

    const res: BillFetchApiResponse = yield call(
      [billerDetailsHttp, billerDetailsHttp.post],
      "/api/v1/bill/billfetch",
      action.payload,
    );

    const billResult = res?.data;

    // console.log("ooooo",{ billResult });
    // backend: { data: {...}, status:true ... }
    yield put(billFetchSucceeded(billResult));

    // Ref/session context ko persist karo (reload-safe)
    // customerParams + mobile number hume input payload se milte hain
    const billContext = {
      billerId: payload?.billerId,
      refId: billResult?.refId,
      customerParams: payload?.customerParams,
      customerMobileNumber: payload?.customerMobileNumber,
    };

    // per-biller refId
    refSessionStore.setBillFetchRef(
      payload.billerId,
      billResult.refId,
      15 * 60_000,
    );

    // generic context (last bill) – raw helper
    refSessionStore.setRaw(
      `billContext:${payload.billerId}`,
      JSON.stringify(billContext),
      15 * 60_000,
    );
  } catch (err: any) {
    const normalized: NormalizedError = err; // interceptor already normalize
    yield put(billFetchFailed(normalized));
  }
}

export function* billFetchWatcher() {
  // console.log("billFetchRequested in saga:", billFetchRequested);

  yield takeLatest(billFetchRequested.type, handleBillFetch);
}
